import { Button, Col, Form, Row, Space, Table } from "antd";
import { useForm } from "antd/es/form/Form";
import { receiveService } from "api";
import { InputFields, ListActionButton, Notification } from "components/common";
import React, { useEffect, useState } from "react";
import { FIELD_TYPE } from "types/enums";
import { DataFormField } from "types/models/input-field-type";
import { columnsAddGroup } from "./config";

const { INPUT } = FIELD_TYPE;
const cssProps = {
  css: { xl: 24, lg: 24 },
  labelCol: { xl: 6, lg: 6, md: 10 },
  wrapperCol: { xl: 18, lg: 18, md: 14 },
};
const data: DataFormField[] = [
  {
    type: INPUT,
    name: "tenDoanKham",
    label: "Tên đoàn",
    ...cssProps,
  },
  {
    type: INPUT,
    label: "Ghi chú",
    name: "ghiChu",
    ...cssProps,
  },
];

const ModalAddGroup = (props) => {
  const { getLitGroup, closeModal, dataAddGroup, type, setType, openModal } =
    props;
  const [id, setId] = useState(null);
  const handleAddGroup = async () => {
    const value = form.getFieldsValue();
    if (type) {
      try {
        await receiveService.putLitGroup({
          ...value,
          id: id,
        });

        Notification("success", "Cập nhật đoàn thành công");
        getLitGroup();
        setType(false);
        form.resetFields();
        setId(null);
        // closeModal();
      } catch (error) {
        Notification("error", "Cập nhật đoàn không thành công");
      }
    } else {
      try {
        await receiveService.postLitGroup(value);

        Notification("success", "Thêm mới đoàn thành công");
        getLitGroup();
        form.resetFields();
        setType(false);
        // closeModal();
      } catch (error) {
        Notification("error", "Thêm mới đoàn không thành công");
      }
    }
  };
  const [form] = useForm();

  const handleEdit = async (r) => {
    form.setFieldsValue(r);
    setId(r.id);
    setType(true);
  };

  const handleDelete = async (id) => {
    try {
      await receiveService.deletetLitGroup(id);

      Notification("success", "Xóa đoàn thành công");
      getLitGroup();
      form.resetFields();
      // closeModal();
    } catch (error) {
      Notification("error", "Xóa đoàn không thành công");
    }
  };

  columnsAddGroup.find((e) => e.dataIndex === "actions").render = (
    v,
    r: any
  ) => (
    <ListActionButton
      editFunction={() => handleEdit(r)}
      deleteFunction={() => handleDelete(r.id)}
    />
  );
  const handleClose = () => {
    if (type) {
      setType(false);
      form.resetFields();
    } else {
      closeModal();
    }
  };

  return (
    <Space direction="vertical" style={{ width: "100%" }}>
      <Row>
        <Col span={14}>
          <Table
            columns={columnsAddGroup}
            dataSource={dataAddGroup}
            bordered
            pagination={false}
            scroll={{ y: 800 }}
          />
        </Col>
        <Col span={10}>
          <Form form={form}>
            <Space direction="vertical" style={{ width: "100%" }}>
              <Row gutter={[16, 8]}>
                <InputFields data={data} />
              </Row>
            </Space>
          </Form>
        </Col>
      </Row>
      <Row justify={"end"} gutter={[16, 4]}>
        <Col>
          <Button type="text" className="btn-cancel" onClick={handleClose}>
            {type ? "Huỷ cập nhật" : "Huỷ"}
          </Button>
        </Col>
        <Button type="primary" onClick={handleAddGroup}>
          {type ? "Cập nhật" : "Thêm mới"}
        </Button>
      </Row>
    </Space>
  );
};

export default ModalAddGroup;
